import React from 'react';

const RedFlag = () => {
    return (
        <div style={{ padding: '20px' }}>
            <h2>RedFlag</h2>
            <p>RedFlag Management (Under Construction)</p>
        </div>
    );
};

export default RedFlag;
